// STATE
const state = () => ({
    copiedTemplateScreen: null,
    copiedTemplateEmail: null,
    copiedTemplateSMS: null,
});

export default state;